import axios from 'axios';

export const FETCH_CMSPAGE = 'AKASHA_FETCH_CMSPAGE';
export const FETCH_CMSPAGE_PENDING = `${FETCH_CMSPAGE}_PENDING`;
export const FETCH_CMSPAGE_FULFILLED = `${FETCH_CMSPAGE}_FULFILLED`;
export const FETCH_CMSPAGE_REJECTED = `${FETCH_CMSPAGE}_REJECTED`;

export function getCmsPage(
  pageUrl: string,
  queryParams: any,
  additionalHeaders?: any,
  language = 'en'
) {
  let cmsPageUrl = pageUrl;
  let queryStr = `cmsPageById=${cmsPageUrl}`;
  cmsPageUrl = `${process.env.REACT_APP_CMS_PAGE_SERVICE_ENDPOINT}?${queryStr}`;
  if (pageUrl.startsWith('/')) {
    cmsPageUrl = pageUrl.replace(`/${language}/`, '/');
    queryStr = `cmsPageUrl=${cmsPageUrl}&languageCode=${language}&campfireView=true`;
    cmsPageUrl = `${process.env.REACT_APP_CMS_PAGES_SERVICE_ENDPOINT}?${queryStr}`;
  }
  if (queryParams) {
    cmsPageUrl += `&${queryParams}`;
  }
  return {
    type: FETCH_CMSPAGE,
    payload: axios.get(cmsPageUrl, {
      headers: {
        ...additionalHeaders,
        "Customer-Facing-Tool": process.env.REACT_APP_CFT,
        CFT: process.env.REACT_APP_CFT,
        MSessionId: sessionStorage.getItem("sessionId"),
      },
    }),
    meta: { pageUrl, language },
  };
}
